import { useCarouselSpringboardExp } from 'experiments/pen-4889_v1_hp_carousel_springboard'

import { CarouselImage } from './CarouselImage'

export const SingleColumnCarouselItem = ({
  item,
  imageWidth,
  imageHeight,
}: {
  item: string
  imageWidth: number
  imageHeight: number
}) => {
  const { inPen4889Experiment } = useCarouselSpringboardExp()

  return (
    <div className={inPen4889Experiment ? 'mc-mb-1' : 'mc-mb-3'}>
      <CarouselImage
        className='mc-corners--md'
        key={item}
        src={item}
        width={imageWidth}
        height={imageHeight}
      />
    </div>
  )
}
